import React from 'react';
import { FaArrowLeft, FaLongArrowAltLeft, FaLongArrowAltRight, FaRegWindowMaximize, FaWaveSquare } from 'react-icons/fa';
import {   peerlessDataForOurBraids } from '../Components/PeerlessData';
import Slider from 'react-slick';
import { Tooltip } from 'react-tooltip';

const HairServicePage4 = ({setNavLinks, handleImageExpansion, slidesToShow1, setSlidesToShow1, sliderState5, setSliderState5, handleAfterChange5}) => {


  React.useEffect(() => {
    // retrieve slider state from local storage on component mount
    const storedState = JSON.parse(sessionStorage.getItem('sliderState5'));
    if(storedState){setSliderState5(storedState)} 
    const handleResize = () => {
      if (window.innerWidth >= 1030) {
        setSlidesToShow1(6);
      } else if (window.innerWidth >= 600) {
        setSlidesToShow1(5);
      } else if (window.innerWidth >= 300) {
        setSlidesToShow1(2);
      } else {
        setSlidesToShow1(1);
      }

      
    };

    handleResize()
    window.addEventListener('resize', handleResize);
    
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setSlidesToShow1, setSliderState5]);

    const settings = {

        dots: false,
        Infinity: true,
        slidesToShow: slidesToShow1,
        slidesToScroll: 1,
        lazyLoad: true,
        Speed: 200,
        swipe: true,
        swipeToSlide: true,

       
    }


  return (
    <div className='container-fluid'> 
            <div className='close-window-icon' ><FaArrowLeft color='#1b2328' onClick={()=>{
              
              setNavLinks({serviceLink: true})
              sessionStorage.setItem("currentSession", JSON.stringify({serviceLink: true}));
              }}/> </div>
            <h1 className='title'><FaWaveSquare color='#1b2328' /> Braid Collections </h1>



             {/* Braids Collection */}
        <div className="hair-service-container">

                <h1>Slide to see more <FaLongArrowAltRight/></h1>

                <Slider {...settings} afterChange={handleAfterChange5} initialSlide={sliderState5.currentSlide}>

                        {

                            peerlessDataForOurBraids.map((ourHair)=>{

                            return(
                                    <article className='hair-service-card' key={ourHair.id} > 
                                            
                                            <div className="hair-service-img-container">
                                            <img src={require(`../Images/ServiceImages/${ourHair.folder}/${ourHair.image}`)} alt="Hair Styles"/>
                                            </div>

                                            <div className="hair-service-details">

                                                <p>{ourHair.name} </p>

                                                
                                            </div>

                                            <div className='enlarge-img-icon' data-tooltip-id='my-tooltip' data-tooltip-content='Expand'><Tooltip id='my-tooltip'/><FaRegWindowMaximize onClick={()=>handleImageExpansion(ourHair.id)} color='white'/></div>
                                            

                                    </article>
                            )

                        })
                        }

                </Slider>
        </div>

       
            
                <div className='see-more' onClick={()=>{
                  setNavLinks({hairServicesLink3: true})
                  sessionStorage.setItem("currentSession", JSON.stringify({hairServicesLink3: true}));
                  }}>
                    
                    <p> <FaLongArrowAltLeft/> Go Back </p>
                
                </div>
         
  
             
    </div>
  )
}

export default HairServicePage4;